/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import {
    IAviDataGridConfig,
} from 'ng/modules/data-grid/components/avi-data-grid/avi-data-grid.types';

import { TTrafficLog } from '../../traffic-logs/traffic-logs.types';

import * as l10n from './log-significance.l10n';

import './log-significance.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component for displaying Significance section in the log cinematic view or in the list view
 *     row expanded content.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-significance',
    templateUrl: './log-significance.component.html',
})
export class LogSignificanceComponent implements OnInit, AfterViewInit {
    /**
     * Whether the component is in compact mode.
     * Used in log list view to display expanded content.
     */
    @Input()
    public compactMode = false;

    @Input()
    public significantLog: TTrafficLog['significant_log'];

    /**
     * Populated only when the component is used by the cinematic view for its closing.
     */
    @Output()
    public onFilterAdd: EventEmitter<void> = new EventEmitter<void>();

    /**
     * Datagrid template for the significance field.
     */
    @ViewChild('significanceFieldTemplateRef')
    public significanceFieldTemplateRef: TemplateRef<HTMLElement>;

    public significanceGridConfig: IAviDataGridConfig;

    constructor(private readonly l10nService: L10nService) {
        this.l10nService.registerSourceBundles(dictionary);
    }

    public ngOnInit(): void {
        // needed to be set on init for the data grid to setup inital props
        this.significanceGridConfig = {
            fields: [],
            layout: {
                compact: this.compactMode,
                showFooter: !this.compactMode,
                hideCheckboxes: true,
            },
            isGridExpandable: true,
        };
    }

    /** @override */
    public ngAfterViewInit(): void {
        // needed in ngAfterViewInit to fetch the templateRef from ViewChild
        this.significanceGridConfig.fields = [
            {
                label: this.l10nService.getMessage(l10nKeys.significanceLabel),
                icon: 'bubble-exclamation',
                id: 'significance',
                templateRef: this.significanceFieldTemplateRef,
            },
        ];
    }
}
